import * as React from 'react';
import loadingIcon from '../assets/imgs/common/loading.gif';

export default React.memo(() => (
  <div className="dut-loading">
    <div className="dut-loading-bg" />
    <img className="dut-loading-icon" src={loadingIcon} alt="Loading" />
  </div>
));
